import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {yellow, primary} from '@modifi/colors'

import {colorMap} from '../common'

type DummyDivProps = {
  height: string
  backgroundColor?: string
}

export const DummyDiv = styled.div<DummyDivProps>`
  height: ${({height}): FlattenSimpleInterpolation =>
    css`
      ${height}px
    `};
  width: 100%;
  ${({backgroundColor}): FlattenSimpleInterpolation | string =>
    backgroundColor && colorMap?.[backgroundColor]
      ? css`
          background-color: ${colorMap?.[backgroundColor]};
        `
      : ''}
`

export const TopComponent = styled.div`
  background-color: ${primary};
  height: 90px;
`

export const BottomComponent = styled.div`
  background-color: ${yellow};
  height: 90px;
`
